<template>
    <div class="outer">

        <!-- 审批记录弹窗 -->
        <el-dialog width="50%" destroy-on-close title="审批记录" v-if="claimApprovalVisible" @close="closeBuyApprovalDialog" :close-on-click-modal="false" :visible="claimApprovalVisible">
            <template v-if="stageList.length > 0">
                <el-timeline style="margin-top: 30px">
                    <el-timeline-item
                        :timestamp="item.endTime"
                        v-for="(item, i) in stageList"
                        :type="item.approvalResult === '1' ? 'success' : item.approvalResult === '2' ? 'danger' : ''"
                        :key="i"
                    >
                        {{ i+1 }}.<template v-if="item.approvalResult">
                        【已审批-{{ item.approvalResultName }}】, 【操作人：{{
                            item.dealUserName
                        }}】, 【意见/建议：{{ item.opinion }}】
                        </template>
                        <template v-else>
                        【待审批】 【操作人：{{ item.dealUserName }}】
                        </template>
                    </el-timeline-item>
                </el-timeline>

                <div style="position: absolute;bottom: 20px;right: 20px;">
                    当前审批人: {{ currentApprovalUser }}
                </div>
            </template>

            <el-empty v-else description="无需审批"></el-empty>
                
        </el-dialog>

        <!-- 选择货物 -->
        <el-dialog width="65%" title="货物采购-选择货物" :close-on-click-modal="false" v-if="selectGoodsVisible"
            :visible="selectGoodsVisible" @close="selectGoodsVisible = false">
            <addGoods claimDialogType="edit" :checkedList="[]" @checkGoods="checkGoods"></addGoods>
        </el-dialog>

        <!-- 新建请购单 -->
        <el-dialog width="35%" :close-on-click-modal="false" :title="dialogTitle" :visible="requestVisable" @close="closeRequestDialog">
            <el-form ref="requestForm" :model="requestForm" :rules="requestRules" label-width="130px" style="width: 89%;">

                <el-form-item label="请购用途类型" prop="usageType" required>
                    <el-select style="width: 100%" v-model="requestForm.usageType" @change="usageTypeChange" :disabled="dialogType === 'edit'">
                        <el-option value="1" label="项目用" :disabled="!isXiaos"></el-option>
                        <el-option value="2" label="部门用"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="项目名称" prop="chanceId" v-if="requestForm.usageType === '1' && isXiaos" required>
                    <el-select style="width: 100%" filterable v-model="requestForm.chanceId" placeholder="请选择"
                        :disabled="dialogType === 'edit'">
                        <el-option v-for="(item, i) in projectList" :key="i" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="货物名称" prop="goodsName" required>
                    <div class="flex-center">
                        <el-input style="width: 100%" readonly v-model="requestForm.goodsName" placeholder="选择货物后回显"></el-input>
                        <el-button style="margin-left: 10px;" type="primary" :disabled="dialogType === 'edit'"
                            @click="selectGoodsVisible = true">选择货物</el-button>
                    </div>
                </el-form-item>

                <!-- <el-form-item label="货物类别" prop="goodsClassName" required>
                    <div class="flex-center">
                        <el-input style="width: 100%" readonly v-model="requestForm.goodsClassName" placeholder="选择货物后回显"></el-input>
                    </div>
                </el-form-item> -->

                <el-form-item label="货物品牌" prop="goodsBrand" required>
                    <div class="flex-center">
                        <el-input style="width: 100%" readonly v-model="requestForm.goodsBrand" placeholder="选择货物后回显"></el-input>
                    </div>
                </el-form-item>
                
                <el-form-item label="货物型号" prop="goodsType" required>
                    <div class="flex-center">
                        <el-input style="width: 100%" readonly v-model="requestForm.goodsType" placeholder="选择货物后回显"></el-input>
                    </div>
                </el-form-item>

                <el-form-item label="请购数量" prop="goodsNum" required>
                    <div class="flex-center">
                        <el-input style="width: 100%" type="number" v-model="requestForm.goodsNum" placeholder="选择货物后回显"></el-input>
                    </div>
                </el-form-item>

                <el-form-item label="备注" prop="remarks">
                    <div class="flex-center">
                        <el-input style="width: 100%" v-model="requestForm.remarks" type="textarea" placeholder="请输入备注"></el-input>
                    </div>
                </el-form-item>
       
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeRequestDialog">取 消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="submitRequest">确 定</el-button>
            </span>
        </el-dialog>

        <div class="topSearch">
            <el-form class="queryRow" inline :model="queryForm">
                <el-form-item label="请购单状态" class="queryCol">
                    <el-select v-model="queryForm.requestState" @change="onSearch" clearable @clear="onSearch">
                        <el-option :value="1" label="待审批"></el-option>
                        <el-option :value="2" label="审批完成"></el-option>
                        <el-option :value="3" label="审批驳回"></el-option>
                        <el-option :value="4" label="已入库"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>


            <el-button type="primary" icon="el-icon-plus" @click="openRequestDialog('add')">新建请购单</el-button>
        </div>

        <el-table border v-loading="loading" class="table" :row-style="{ height: '50px' }"  style="width: 100%;height: 70vh;overflow: auto;" :cell-class-name="cellClassName" :data="requestGoodsList">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column align="center" label="请购单编号" prop="requestNo" width="180">
            </el-table-column>
            <el-table-column align="center" label="请购单状态" prop="requestState">
                <template slot-scope="scope">
                    <el-tag :type="RstateTagType(scope.row.requestState)">{{ scope.row.requestStateName }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="请购人" prop="requestUserName">
            </el-table-column>    
            <el-table-column align="center" label="货物名称" prop="goodsName">
            </el-table-column>
            <el-table-column align="center" label="货物品牌" prop="goodsBrand">
            </el-table-column>
            <el-table-column align="center" label="货物型号" prop="goodsType">
            </el-table-column>
            <el-table-column align="center" label="货物配置" prop="goodsConfig">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top" width="300">
                        <p>{{ scope.row.goodsConfig }}</p>
                        <div slot="reference">
                            <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig}}</p>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column align="center" label="请购数量" prop="goodsNum">
                <template slot-scope="scope">
                    <span>{{ scope.row.goodsNum }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="货物单位" prop="goodsUnit">
            </el-table-column>
            <el-table-column align="center" label="备注" prop="remarks">
            </el-table-column>
            <el-table-column align="center" label="关联采购单号" prop="purchaseNo">
                <template slot-scope="scope">
                    
                    <span v-if="scope.row.purchaseNo">{{ scope.row.purchaseNo }}</span>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" prop="operation" width="200">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" v-if="scope.row.requestState == 1 || scope.row.requestState == 3" @click="openRequestDialog('edit', scope.row)">修改</el-button>
                    <el-button type="text" icon="el-icon-document" @click="openApprovalVisible(scope.row.requestNo,'add')">审批记录</el-button>
                    <el-button type="text" v-if="scope.row.requestState == 1 || scope.row.requestState == 3" class="Danger-text" icon="el-icon-delete" @click="deleteRequest(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="queryForm.page"
                background layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import addGoods from './addGoods.vue';
import { approvalStageList } from '@/api/goods/buyForm.js';
import { getXzRequestGoodsList, addXzRequestGoodsList, deleteRequestGoods, updateXzRequestGoods } from '@/api/goods/applyForm';
import { getProjects, getAllProject } from '@/api/work/WorkOrderList.js';
import { isSales } from "@/views/goods/permission.js";
export default {
    data() {
        return {
            btnLoading: false, // 提交按钮是否禁用
            selectGoodsVisible: false,
            isXiaos: isSales(), // 销售类角色（roleId 2、3）可选项目用/商机
            projectList: [], // 商机列表（销售仅自己名下）
            requestForm: {
                goodsName: '',
                goodsClassName: '',
                goodsBrand: '',
                goodsType: '',
                goodsNum: '',
                usageType: '', // 请购用途类型 1项目用 2部门用
                chanceId: '', // 商机（仅销售、项目用）
            },
            requestRules: {
                usageType: [
                    { required: true, message: '请选择请购用途类型' },
                ],
                chanceId: [
                    { required: true, message: '请选择项目名称' },
                ],
                goodsType: [
                    { required: true, message: '请选择货物' },
                ],
                goodsName: [
                    { required: true, message: '请选择货物' },
                ],
                goodsNum: [
                    { required: true, message: '请选择货物' },
                ],
                goodsUnit: [
                    { required: true, message: '请选择货物' },
                ],
                goodsClassName: [
                    { required: true, message: '请选择货物' },
                ],
                goodsBrand: [
                    { required: true, message: '请选择货物' },
                ],
            },
            requestVisable: false,
            dialogType: '',
            dialogTitle: '',
            total: 0,
            queryForm: {
                requestUserId: sessionStorage.getItem('uid'),
                chanceId: '',
                usageType: '',
                applyState: '',
                page: 1,
                limit: 10,
            },
            requestGoodsList: [],
            loading: false,
            stageList: [], // 审批记录
            claimApprovalVisible: false, // 审批记录弹窗
        }
    },
    created() {
        this.fetchRequestGoodsList();
        this.loadProjectList();
    },
    computed: {
        currentApprovalUser(){
            return this.stageList.find(item => !item.approvalResult)?.dealUserName || '无';
        }
    },
    components: {
        addGoods,
    },
    methods: {
        // 删除请购单
        deleteRequest(id){
            this.$confirm('确定删除请购单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                deleteRequestGoods({
                    id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '操作成功',
                        });
                        this.fetchRequestGoodsList();
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除',
                });
            });
        },
        // 关闭审批记录弹窗
        closeBuyApprovalDialog(){
            this.stageList = [];
            this.claimApprovalVisible = false;
        },
        
        // 打开审批记录弹窗
        async openApprovalVisible(requestNo){
            await this.getApprovalStageList(requestNo);
            this.claimApprovalVisible = true;
        },
        // 获取采购单审批记录
        async getApprovalStageList(requestNo){
            await approvalStageList({
                applyCode: requestNo,
            }).then(res => {
                if(res.code === 200){
                    this.stageList = res.data;
                }
            })
        },
        // 提交请购单
        submitRequest(){
            this.$refs.requestForm.validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    if(this.dialogType === 'add'){
                        addXzRequestGoodsList({
                            "applyNo": "",
                            "goodsCode": this.requestForm.goodsCode,
                            "goodsNum": this.requestForm.goodsNum,
                            "remarks": this.requestForm.remarks,
                            "usageType": this.requestForm.usageType,
                            "chanceId": this.requestForm.chanceId,
                        }).then(res => {
                            this.btnLoading = false;
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '操作成功',
                                });
                                this.fetchRequestGoodsList();
                                this.closeRequestDialog();
                            }
                        })
                    }else if(this.dialogType === 'edit'){
                        updateXzRequestGoods({
                            "id": this.requestForm.id,
                            "goodsCode": this.requestForm.goodsCode,
                            "goodsNum": this.requestForm.goodsNum,
                            "remarks": this.requestForm.remarks,
                            "usageType": this.requestForm.usageType,
                            "chanceId": this.requestForm.chanceId,
                            "requestState": '1',
                            "requestStateName": '审批中',
                        }).then(res => {
                            this.btnLoading = false;
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '操作成功',
                                });
                                this.fetchRequestGoodsList();
                                this.closeRequestDialog();
                            }
                        })
                    }
                    
                }
            });
        },
        // 选择货物回调（保留已填写的用途类型与商机）
        checkGoods(row) {
            const { usageType, chanceId } = this.requestForm;
            this.requestForm = { ...row, usageType, chanceId };
            this.requestForm.remarks = '';
            this.selectGoodsVisible = false;
        },
        // 关闭请购单弹窗
        closeRequestDialog(){
            this.requestForm = {};
            this.$refs.requestForm.resetFields();
            this.requestVisable = false;
        },
        // 打开请购单弹窗
        openRequestDialog(type,row){
            if(type === 'add'){
                this.requestForm = {
                    goodsName: '',
                    goodsClassName: '',
                    goodsBrand: '',
                    goodsType: '',
                    goodsNum: '',
                    usageType: '',
                    chanceId: '',
                };
                this.dialogType = 'add';
                this.dialogTitle = '新建请购单';
            }else if(type === 'edit'){
                this.requestForm = {...row};
                this.dialogType = 'edit';
                this.dialogTitle = '修改请购单';
            }
            this.requestVisable = true;
            
        },
        // 用途类型切换时清空商机
        usageTypeChange() {
            this.requestForm.chanceId = '';
        },
        // 加载商机列表（销售仅加载自己名下商机，文档 4.3）
        loadProjectList() {
            if (this.isXiaos) {
                getProjects().then(res => {
                    if (res.code === 200) {
                        this.projectList = res.data;
                    }
                });
            }
        },
        // 打开弹窗
        // 当每页条数变化
        onSizeChange(e) {
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.fetchRequestGoodsList();
        },
        // 当页码发生变化时
        onCurrentChange(e) {
            this.queryForm.page = e;
            this.fetchRequestGoodsList();
        },
        onSearch() {
            this.queryForm.page = 1;
            this.fetchRequestGoodsList();
        },
        // 表格单元格样式
        cellClassName({ row, column }) {
            if (column.type === 'expand' && row.usageType != '1') {
                return 'hidden-row'
            }
            return ''
        },
        fetchRequestGoodsList() {
            this.loading = true;
            getXzRequestGoodsList(this.queryForm).then(res => {
                if (res.code === 200) {
                    this.total = res.count;
                    this.requestGoodsList = res.data;
                    this.loading = false;
                }
            })
        },
        RstateTagType(requestState){
            switch (requestState) {
                case '1':
                    return '';
                    break;
                case '2':
                    return 'success';
                    break;
                case '3':
                    return 'danger';
                    break;
                case '4':
                    return 'primary';
                    break;
            }

        },
    },
}
</script>
<style lang="scss" scoped>
.outer {

    .listTop {
        margin-bottom: 15px;
        font-size: 15px;
        font-weight: 450;
    }

    .demo-table-expand {
        font-size: 0;
        margin-left: 65px;

        ::v-deep .el-form-item__label {
            width: 90px;
            color: #99a9bf;
        }

        .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 50%;
        }
    }

    .clearfix {
        display: flex;
        justify-content: flex-end;
    }

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }

    .detailTable {
        ::v-deep .el-checkbox__input {
            &.is-checked {
                .el-checkbox__inner {
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .table {

        ::v-deep .hidden-row .cell {
            visibility: hidden;
        }

        ::v-deep .el-tooltip__popper {
            font-size: 14px;
            max-width: 40%
        }

        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>